'use client';
import useHash from "hooks/useHash";
import { ShopifyCollection } from "lib/shopify/types";
import { cn } from "utils/cn";

export function CollectionNavigation({ collections}: { collections: ShopifyCollection[] }) {
    const hash = useHash();

    return (
        <div className="flex justify-around flex-col items-center lg:flex-row w-full xl:w-3/4">
            {collections.map((collection, index) => (
                <a key={collection.handle} href={`#${collection.handle}`} className={cn("hover:text-fp-green", {'border-fp-green border-b-2' : hash? collection.handle === hash: index === 0})}>
                    {collection.title}
                </a>
            ))}
        </div>
    );
}